export default "__VITE_ASSET__B1WF$PId__"